import React, {useState} from 'react';
import TogglerBody from '../TogglerBody';
import FlagCustomisationItemCounter from './FlagCustomisationItemCounter';
import FlagCustomisationItemInputs from './FlagCustomisationItemInputs';
import './flagCustomisation.scss';

const flagItemArrInputs = [
  {
    title: 'Blacklist Names',
    targetTogler: 'Target local dictionary',
    counter: [],
    targetSlader: '',
    currentAction: 'Ban',
    chooseActionTarget: 'Punishment',
    trigger: 'localDictionary',
    keyName: 'dictionaryPunishment',
    strictWords: 'strictWords',
    wildcardWords: 'wildcardWords',
  },
];

const flagItemArr = [
  {
    title: 'Cross-server deteciton',
    targetTogler: 'Target profiles that previously used for raids',
    counter: [],
    targetSlader: '',
    currentAction: 'Log',
    chooseActionTarget: 'Punishment',
    trigger: 'crossServerDetection',
    keyName: 'crossServerPunishment',
  },
  {
    title: 'Account Age',
    targetTogler: 'Target profiles with a certain creation date',
    counter: [
      {
        title: 'Minimum Age',
        target: '',
        time: 'day',
        keyName: 'minimumAccountAge',
        keyTime: 'minimumAccountAgeType',
      },
    ],
    targetSlader: '',
    currentAction: '',
    chooseActionTarget: 'Punishment',
    trigger: 'accountAgeEnabled',
    keyName: 'accountAgePunishment',
  },
  {
    title: 'Advertisement',
    targetTogler: 'Target ads profiles',
    counter: [],
    targetSlader: '',
    currentAction: '',
    chooseActionTarget: 'Punishment',
    trigger: 'advertisement',
    keyName: 'advertisementPunishment',
  },
  {
    title: 'No Avatar',
    targetTogler: 'Target profiles without avatar',
    counter: [],
    targetSlader: '',
    currentAction: 'Warn',
    chooseActionTarget: 'Punishment',
    trigger: 'noAvatarTrigger',
    keyName: 'noAvatarPunishment',
  },
];

const FlagCustomisationAntiRaid = ({title, text, data}) => {
  const [isCustommisation, setIsCustommisation] = useState(data?.enabled);

  const isTitle = true;
  return (
    <div className="advance_seting_with_title_wrap">
      {isTitle && (
        <div className="overview_component_content_head">
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
      )}
      <div className="status_block_wrap flag_customisation_wrap">
        <div className="status_block_wrap_bg"></div>
        <img className="status_block_wrap_img" src="/img/FlagSettings.svg" alt="" />
        <h3>Flag Customisation</h3>
        <div className="status_block_item" style={{borderBottom: '1px solid #8D99A3'}}>
          <div className="status_block_item_toggler">
            <TogglerBody
              isOn={isCustommisation}
              setIsOn={setIsCustommisation}
              keyName={'enabled'}
              advance
            />
            <p>Use advanced parameters</p>
          </div>
        </div>
        <div className="status_block_item flag_customisation_wrap_block_plug">
          <div
            className={`status_block_item flag_customisation_wrap_block ${
              isCustommisation ? '' : 'flag_customisation_wrap_block_blur'
            }`}>
            <div className="flag_customisation_wrap_block_item_one">
              {flagItemArrInputs.map((item, idx) => (
                <FlagCustomisationItemInputs key={idx} item={item} data={data} />
              ))}
            </div>
            <div className="flag_customisation_wrap_block_item_two">
              {flagItemArr.map((item, idx) => (
                <FlagCustomisationItemCounter key={idx} item={item} data={data} />
              ))}
            </div>
          </div>
          {/* <div className={`status_block_item flag_customisation_wrap_block ${isOnMonitor ? '' : 'flag_customisation_wrap_block_blur'}`}>
                    {flagItemArr2.map((item, idx) => (
                            <FlagCustomisationItemCounter
                            item={item}
                            />
                    ))}
                </div> */}
          {!isCustommisation && (
            <div className="flag_customisation_wrap_plug">
              <p>Enable Advanced Parameters 🙏🏻</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FlagCustomisationAntiRaid;
